import constantes from '../helpers/constanteHelper'

import { useNavigate } from 'react-router-dom'

import Image from 'react-bootstrap/Image'

import produtoDefault from '../images/produto-default.png'

function CardEmpresGenerico({ empresa, resolucaoMobile, desativarLink, idioma, pathCatalogo, secaoEmpresas = 'empresas' }) {
    const navigate = useNavigate()

    function retornarLinkImagemEmpresa(idioma) {
        if (idioma === 'en') {
            return empresa['Link da logo da empresa (Inglês)'] ? empresa['Link da logo da empresa (Inglês)'] : empresa['Link da logo da empresa'] ? empresa['Link da logo da empresa'] : undefined
        } else if (idioma === 'es') {
            return empresa['Link da logo da empresa (Espanhol)'] ? empresa['Link da logo da empresa (Espanhol)'] : empresa['Link da logo da empresa'] ? empresa['Link da logo da empresa'] : undefined
        } else if (idioma === 'fr') {
            return empresa['Link da logo da empresa (Francês)'] ? empresa['Link da logo da empresa (Francês)'] : empresa['Link da logo da empresa'] ? empresa['Link da logo da empresa'] : undefined
        } else {
            return empresa['Link da logo da empresa'] ? empresa['Link da logo da empresa'] : undefined
        }
    }

    return (
        <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' onClick={desativarLink ? () => { } : () => { navigate(`/${pathCatalogo}/${secaoEmpresas}/${empresa['Slug (Url)']}`) }} style={{ cursor: 'pointer', width: '319px', height: '180px', background: constantes.CORES.BRANCO_PADRAO, borderRadius: '20px' }}>
            <Image style={{ height: '180px', objectFit: 'contain', padding: '25px' }} src={retornarLinkImagemEmpresa(idioma) ?? produtoDefault} alt='logo' fluid />
        </div>
    );
}
export default CardEmpresGenerico;
